import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { LoginAndUserManagerService } from '../../api/managers/login-and-user-manager.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.less']
})
export class ForgotPasswordComponent implements OnInit
{

    email: string;
    errorMessage: string;
    showEmailConfirmation = false;

    isLoading = false;

    constructor(private router: Router,
                private loginAndUserManagerService: LoginAndUserManagerService)
    { }

    ngOnInit()
    {
    }

    onForgotPassword(form: NgForm)
    {
        this.email = form.value.email;
        this.isLoading = true;
        this.loginAndUserManagerService.forgotPassword(this.email)
            .subscribe(response =>
            {
                this.showEmailConfirmation = true;
                this.isLoading = false;
            }, err =>
            {
                this.isLoading = false;
                if (err.status === 200)
                {
                    this.showEmailConfirmation = true;
                    return;
                }
                this.errorMessage = err.error.ModelState.Error;
            });
    }

    goToMain()
    {
        this.router.navigate(['welcome']);
    }
}
